import { QUESTION_TYPE, RequestGuideNode } from 'resources/CustomerIntakeFlow/requestGuide';
import { isPresent } from 'utils/isPresent';

export const isHcpAssistIndustryNode = (node: RequestGuideNode): boolean => {
  if (node.type !== QUESTION_TYPE || node.question !== 'Industry' || !node.answers) {
    return false;
  }

  return node.answers.some((answer) => isPresent(answer.hcpAssistMetadata));
};
